<template>
	<div v-loading="loading">
		<div class="title">
			<el-row style="margin: 0 0 10px 0 ;">
				<el-col :lg="22">
					<div class="waiTitel">
						<div class="green01"></div>
						<div class="title"
							style="margin: 0 0 0 3px; font-family: SourceHanSansCN-Bold; font-size: 18px;">月度统计</div>
					</div>
				</el-col>
				<el-col :lg="2">
					<el-button @click="refresh()" size="mini" icon="el-icon-refresh"
						style="background-color: #ffffff; color: #000000; float: right;">刷新
					</el-button>
				</el-col>
			</el-row>
		</div>
		<div>
			<el-row :gutter="10">
				<el-col :lg="17" class="grid-content">
					<div class="">
						<div class="topTitle">
							<div class="green02"></div>
							<div class="topTitleSmall">数据概览</div>
						</div>
					</div>
					<el-row class="main-content">
						<el-col :lg="6">
							<div class="main-title">
								销售总额
							</div>
							<div class="main-number">
								￥{{tableData.total}}
							</div>
						</el-col>
						<el-col :lg="6">
							<div class="main-title">
								微信销售额
							</div>
							<div class="main-number">
								￥{{tableData.wechat}}
							</div>
						</el-col>
						<el-col :lg="6">
							<div class="main-title">
								客数(人)
							</div>
							<div class="main-number">
								{{tableData.customer}}
							</div>
						</el-col>
						<el-col :lg="6">
							<div class="main-title">
								新增会员数
							</div>
							<div class="main-number">
								{{tableData.vip}}
							</div>
						</el-col>
					</el-row>
				</el-col>
				<el-col :lg="6" :offset="1" class="grid-content">
					<div class="bg-purple">
						<div class="topTitle">
							<div class="green02"></div>
							<div class="topTitleSmall">营销销售概览</div>
						</div>
						<div class="topRight">
							<el-row>
								<el-col :lg="11" :offset="1">
									<div class="f01">美团销售额</div>
								</el-col>
								<el-col :lg="11" :pull="1">
									<div class="f02" style="float: right;">
										{{(tableData.meituan /100).toFixed(2)}}
									</div>
								</el-col>
							</el-row>
							<div style="width: 280px;height: 1px;background-color:#EFEFEF ;"></div>
							<el-row>
								<el-col :lg="11" :offset="1">
									<div class="f01">会员销售额</div>
								</el-col>
								<el-col :lg="11" :pull="1">
									<div class="f02" style="float: right;">
										{{(tableData.vipTotal /100).toFixed(2)}}
									</div>
								</el-col>
							</el-row>
							<div style="width: 280px;height: 1px;background-color:#EFEFEF ;"></div>
							<el-row>
								<el-col :lg="11" :offset="1">
									<div class="f01">Halo销售额</div>
								</el-col>
								<el-col :lg="11" :pull="1">
									<div class="f02" style="float: right;">
										{{(tableData.haloTotal /100).toFixed(2)}}
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="tableCol">
			<el-row style="margin-top: 10px;">
				<el-col :lg="20">
					<div>
						查询月份
						<el-date-picker type="month" placeholder="选择月份" v-model="form.month" @change="getOrderMonth()"
							size="small" style="width: 200px;margin-right: 10px;" value-format="yyyy-MM">
						</el-date-picker>
						门店
						<el-select v-model="form.storeName" @change="getOrderMonth()" size="small" placeholder="选择门店">
							<el-option v-for="item in store" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :lg="4">
					<div style="float: right;">
						<el-button @click="getOrderMonth" size="small"
							style="color: #ffffff; background: #4AB52E;border-radius: 5px;">筛选</el-button>
						<el-button @click="getMonthExport" size="small" style="color: #000000; border-radius: 5px;">导出
						</el-button>
					</div>
				</el-col>
			</el-row>
			<el-table :data="dayData" stripe=""
				:header-cell-style="{background: '#d8d8d8', 'text-align': 'center', 'font-weight': '800', 'font-size': '16px', color: '#2D2D2D'  }"
				style="width: 100%;margin: 20px 0 30px 0">
				<el-table-column prop="date" label="日期" align="center" fixed="left">
				</el-table-column>
				<el-table-column prop="storeName" label="门店" width="80px" align="center" fixed="left">
				</el-table-column>
				<el-table-column prop="dayStore" label="营业门店" align="center" width="100px">
				</el-table-column>
				<el-table-column prop="dayTotal" align="center" label="总收入" width="100px" sortable>
					<template slot-scope="scope">
						￥{{ scope.row.dayTotal }}
					</template>
				</el-table-column>
				<el-table-column prop="dayWechatTotal" align="center" label="微信支付" width="110px" sortable>
					<template slot-scope="scope">
						￥{{scope.row.dayWechatTotal}}
					</template>
				</el-table-column>
				<el-table-column prop="dayMeituan" align="center" label="美团" width="" sortable>
					<template slot-scope="scope">
						￥{{scope.row.dayMeituan}}
					</template>
				</el-table-column>
				<el-table-column prop="dayVipTotal" align="center" label="会员销售额" width="" sortable>
					<template slot-scope="scope">
						￥{{scope.row.dayVipTotal}}
					</template>
				</el-table-column>
				<el-table-column prop="dayMemberDetail" align="center" label="权益销售额" width="" sortable>
					<template slot-scope="scope">
						￥{{scope.row.dayMemberDetail}}
					</template>
				</el-table-column>
				<!-- 				<el-table-column prop="dayTimeCard" align="center" label="无限卡销售额" width="" sortable>
					<template slot-scope="scope">
						￥{{(scope.row.dayTimeCard /100).toFixed(2)}}
					</template>
				</el-table-column> -->
				<!-- 				<el-table-column prop="dayYingXiao" align="center" label="营销销售额" width="" sortable>
					<template slot-scope="scope">
						￥{{(scope.row.dayYingXiao /100).toFixed(2)}}
					</template>
				</el-table-column> -->
				<!-- 				<el-table-column prop="dayHalo" align="center" label="Halo销售额" width="" sortable>
					<template slot-scope="scope">
						￥{{(scope.row.dayHalo /100).toFixed(2)}}
					</template>
				</el-table-column> -->
				<el-table-column prop="dayCustomer" align="center" label="客数" width="" sortable>
				</el-table-column>
				<el-table-column prop="dayVip" align="center" label="新增会员" width="120px" sortable>
					<template slot-scope="scope">
						{{scope.row.dayVip != null? scope.row.dayVip:0}}
					</template>
				</el-table-column>
				<!-- 				<el-table-column>
					<el-input v-model="dayData.remark" placeholder="请输入内容"></el-input>
				</el-table-column> -->
			</el-table>
		</div>
	</div>
</template>

<script>
	import {
		url,
		formatMoney
	} from "../../../utils/index.js"
	import {
		download,
		downloadFile
	} from '../../../excel/download';
	import requestDefault from '../../../excel/download';
	export default {
		data() {
			return {
				loading: false,
				url: url(),
				form: {
					month: new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
						.getMonth() + 1) : (
						new Date().getMonth() + 1)),
					storeName: undefined,
					store_id: undefined
				},
				// stores:[
				// ],
				// storesEnd:[],
				store: [{
					label: "全部",
					value: undefined,
				}, ],
				tableData: {
					total: 0,
					wechat: 0,
					meituan: 0,
					customer: 0,
					vip: 0,
					vipTotal: 0,
					yingXiao: 0,
					dayStore: 0,
					remark: "",
				},
				dayData: [{
					remark: "",
				}],
				// {
				//  date:'',
				//  storeName:'',
				//  dayCustomer:'',
				//  dayMeituan:'',
				//  dayStore:'',
				//  dayTotal:'',
				//  dayVip:'',
				//  dayVipTotal:'',
				//  dayWechatTotal:'',
				//  dayYingXiao:''
				// }
			}
		},
		methods: {
			getOrderMonth() {
				this.loading = true;
				var a = {
					storeName: this.form.storeName,
					month: this.form.month,
				}
				this.$http.post("dOrder/ordermonthTop", JSON.stringify(a)).then(res => {

					var a = res.body.data
					this.tableData.meituan = a.meituan;
					this.tableData.customer = formatMoney(a.customer, 0);
					this.tableData.vip = formatMoney(a.vip, 0);
					// if(a.storeName){
					// 	this.tableData.vipTotal = 0;
					// 	this.tableData.vip = 0;
					// 	this.tableData.wechat = res.body.data.wechatTotal;
					// }else{
					// 	this.tableData.vipTotal = res.body.data.vipTotal;
					// 	this.tableData.wechat = res.body.data.wechatTotal + this.tableData.vipTotal;
					// }
					this.tableData.vipTotal = a.vipTotal;
					this.tableData.wechat = a.wechatTotal + this.tableData.vipTotal;
					// this.tableData.total = a.payTotal
					this.tableData.total = this.tableData.wechat + a.meituan;
					this.tableData.yingXiao = a.yingXiao;
					this.tableData.haloTotal = a.haloTotal
					this.tableData.total = formatMoney(this.tableData.total / 100)
					this.tableData.wechat = formatMoney(this.tableData.wechat / 100)
					this.getOrderDay();
					this.loading = false;
				})
			},
			getOrderDay() {
				var b = {
					storeId: this.form.store_id,
					storeName: this.form.storeName,
					month: this.form.month,
				}
				this.$http.post("dOrder/ordermonthDown", JSON.stringify(b)).then(res => {
					this.dayData = res.body.data;
					this.dayData.forEach(ele => {
						ele.storeName = this.form.storeName ? this.form.storeName : '/'
						if (ele.dayTotal != null) {
							ele.dayTotal = formatMoney(ele.dayTotal / 100)
						} else {
							ele.dayTotal = 0
						}
						if (ele.dayWechatTotal != null) {
							ele.dayWechatTotal = formatMoney(ele.dayWechatTotal / 100)
						} else {
							ele.dayWechatTotal = 0
						}
						if (ele.dayMeituan != null) {
							ele.dayMeituan = formatMoney(ele.dayMeituan / 100)
						} else {
							ele.dayMeituan = 0
						}
						if (ele.dayVipTotal != null) {
							ele.dayVipTotal = formatMoney(ele.dayVipTotal / 100)
						} else {
							ele.dayVipTotal = 0
						}
						if (ele.dayMemberDetail != null) {
							ele.dayMemberDetail = formatMoney(ele.dayMemberDetail / 100)
						} else {
							ele.dayMemberDetail = 0
						}
					});
				})
				// this.$http.post("dOrder/ordermonthDayStore" ,JSON.stringify(b)).then(res =>{
				// 			this.dayData.dayStore= res.body.data.forEach(ele => ele.dayStore)

				// })
			},
			getStore() {
				this.$http.get("store/list").then(res => {
					res.body.data = res.body.data.filter(ele => ele.businessType == 0)
					for (let i in res.body.data) {
						var a = {
							value: res.body.data[i].title,
							label: res.body.data[i].title
						}
						this.store.push(a)
					}
				})
			},
			getMonthExport() {
				var c ={month:this.form.month}
				if (this.form.storeName) {
					c.storeName=this.form.storeName;
				}
				requestDefault({
					method: 'POST',
					url: 'dOrder/MonthExport',
					data:c,
					headers:{
						'Content_Type':"application/json"
					},
					responseType: 'blob'
				}).then(res => {
					console.log(res)
					downloadFile(res.data, 'ciaojian-Month月度统计', 'xlsx')
				})
			},
			onSubmit() {
				console.log('submit!');
			},
			refresh() {
				this.getOrderMonth();
				this.getOrderDay();
			},
			CloseLoading() {
				this.$nextTick(() => {
					this.loading = false
				})
			}
		},
		mounted() {
			this.getOrderMonth();
			this.getOrderDay();
			this.getStore();
			// this.getMonthExport();
		},
	}
</script>


<style lang="less" scoped>
	.grid-content {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
	}

	.main-number {
		font-family: SourceHanSansCN-Bold;
		font-size: 22px;
	}

	.topRight {
		height: 100px;
	}

	.topRight>div {
		margin-top: 5px;
	}

	.main-content {
		padding: 30px 20px 20px 20px;
	}

	.waiTitel {
		display: flex;
		border-radius: 2px;
	}

	.green01 {
		height: 14px;
		width: 5px;
		background-color: #4AB52E;
		margin: 5px 0 0 0
	}

	.topTitle {
		display: flex;
	}

	.green02 {
		width: 5px;
		height: 5px;
		background: #4AB52E;
		margin: 15px 5px 0 5px
	}

	.topTitleSmall {
		margin: 5px 0 0 0;
		font-size: 18px;
		font-family: SourceHanSansCN-Bold;
	}

	.tableCol {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
		margin: 30px -3px 0px -3px;
		padding: 5px 15px 20px 15px;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #4AB52E;
		border-radius: 5px;
		color: #FFF;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #4AB52E;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled) {
		border-radius: 5px;
	}
</style>